import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView } from 'model/state';
import { Dispatch } from 'redux';
import { AlertsView } from 'components';
import {
  selectAlerts, selectAlertSearch, selectIsAllSelected, selectUserId, selectAlertTotals, selectCurrentPage,
  selectHasMoreAlerts, selectCurrentAlert, selectIsSubmittingAlertAction, selectHasErrorMessage,
  selectIsSelectedAnyAlert, selectSelectedAlertNumber, selectSelectedAlertsToResolveNumber,
  selectIsBulkResolveActionEnabled, selectUserLocations, selectAlertFilters, selectAlarmList
} from 'selectors';
import {
  AlarmLabel, Alert, AlertActionFilter, AlertFilter, AlertTotals, Location, LocationType, Message
} from 'model';
import {
  setSelectAllAlerts, setSelectAlertRow, fetchAlertsByUserId, incrementAlertPage, reinitAlertPageCount, setCurrentAlert,
  clearAlert, updateAlertSearch, openConfirmationDialog, showMessage, clearBulkAlerts, fetchUserLocations,
  updateAlertFilters, fetchAlarmList, clearCriticalAlertAndSubmitFeedback
} from 'actions';

type SelectedValues = {
  alertList: ListView<Alert>,
  isAllSelected: boolean,
  isAnySelected: boolean,
  selectedNumber: number,
  search: string,
  userId: string | null | undefined,
  totals: AlertTotals,
  currentPage: number,
  hasMoreAlerts: boolean,
  currentAlert: Alert | null,
  isSubmittingAction: boolean,
  hasError: boolean,
  alertsToResolveNumber: number,
  isBulkResolveEnabled: boolean,
  userLocations: ListView<Location>,
  filters: AlertActionFilter;
  alarmList: ListView<AlarmLabel>;
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  alertList: selectAlerts(),
  isAllSelected: selectIsAllSelected(),
  isAnySelected: selectIsSelectedAnyAlert(),
  selectedNumber: selectSelectedAlertNumber(),
  search: selectAlertSearch(),
  userId: selectUserId(),
  totals: selectAlertTotals(),
  currentPage: selectCurrentPage(),
  hasMoreAlerts: selectHasMoreAlerts(),
  currentAlert: selectCurrentAlert(),
  isSubmittingAction: selectIsSubmittingAlertAction(),
  hasError: selectHasErrorMessage(),
  alertsToResolveNumber: selectSelectedAlertsToResolveNumber(),
  isBulkResolveEnabled: selectIsBulkResolveActionEnabled(),
  userLocations: selectUserLocations(),
  filters: selectAlertFilters(),
  alarmList: selectAlarmList(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectAll: (selectAll: boolean) => dispatch(setSelectAllAlerts(selectAll)),
  setSelectRow: (select: boolean, alertId: string) => dispatch(setSelectAlertRow(select, alertId)),
  fetchAlertsByUserId: (userId: string, filter: AlertFilter) => dispatch(fetchAlertsByUserId(userId, filter)),
  incrementAlertPage: () => dispatch(incrementAlertPage()),
  reinitAlertPage: () => dispatch(reinitAlertPageCount()),
  setCurrentAlert: (currentAlert: Alert | null) => dispatch(setCurrentAlert(currentAlert)),
  resolveAlert: (alert: Alert) => dispatch(clearAlert(alert)),
  feedbackCriticalAlert: (alert:Alert, feedbackType: string) => dispatch(clearCriticalAlertAndSubmitFeedback(alert, feedbackType)),  
  updateAlertSearch: (search: string) => dispatch(updateAlertSearch(search)),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  showMessage: (message: Message) => dispatch(showMessage(message)),
  clearBulkAlerts: () => dispatch(clearBulkAlerts()),
  fetchUserLocations: (userId: string, types?: LocationType[], page?: number, search?: string) => dispatch(fetchUserLocations(userId, types, page, search)),
  updateAlertFilters: (filters: Partial<AlertActionFilter>) => dispatch(updateAlertFilters(filters)),
  fetchAlarmList: () => dispatch(fetchAlarmList()),
});


export default connect(mapStateToProps, mapDispatchToProps)(AlertsView);
